import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBeam = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 128 128",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinejoin: "round",
		strokeMiterlimit: 2
	},
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "matrix(1,0,0,1,-0.569715,5.0161)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M111.855,8.658L111.855,28.658L74,28.658L74,89.31L111.855,89.31L111.855,109.31L17.284,109.31L17.284,89.31L54,89.31L54,28.658L17.284,28.658L17.284,8.658L111.855,8.658Z",
			style: { fill: "rgb(41,41,41)" }
		})
	})
});
export default SvgBeam;
